/**
 * Created by Ivan on 10.08.2026
 */

const StickersBookWindow2 = Prefab.createWindow("stickers2_book_window", "stickers2_book_window_prefab_json", {
    theme: (stickersBook) => SeasonCollectionsHelper2.getTheme(stickersBook.season),
    bundles: (stickersBook) => SeasonCollectionsHelper2.getWindowBundles("stickers2_book_window", stickersBook.season)
});
